import { render } from "./GenerateThreePartSpecDoc.vue?vue&type=template&id=1df7e0f0"
import script from "./GenerateThreePartSpecDoc.vue?vue&type=script&lang=js"
export * from "./GenerateThreePartSpecDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__